import { useRechercheDossierStore } from './useRechercheDossierStore'
import { useFavorisStore } from '@/features/interface/favoris/favorisStore'
import { useDossierRoutingService } from '../../detail/dossier/useDossierRoutingService'
import { useAjouteDemande } from '../../demande/ajouter/useAjouteDemande'
import { useDemandeRoutingService } from '../../demande/shared'
import { TRANSITION_CANCELED } from '@/features/domaine/machine-etats'

export function useRechercheDossierActions() {
  const routingService = useDossierRoutingService()

  function displayDossier(code: string) {
    routingService.navigateToWithKey(code)
  }

  async function addFavoris() {
    const storeFavoris = useFavorisStore()
    const storeDossier = useRechercheDossierStore()
    storeFavoris.addFavori('dossier', storeDossier.pageRequest!)
  }

  async function addDemande() {
    try {
      const storeAddDemande = useAjouteDemande()
      const demande = await storeAddDemande.showAjoute()

      const { navigateToWithId } = useDemandeRoutingService()
      navigateToWithId(demande.dispositif, demande.id)
    } catch (err) {
      if (err === TRANSITION_CANCELED) return
      console.error(err)
    }
  }

  return { displayDossier, addFavoris, addDemande }
}

